export default __webpack_public_path__ + "static/media/etapa-3.fa19d622.png";